<template>
  <v-row justify="center" v-if="localDialog">
    <v-dialog v-model="localDialog" max-width="980px" scrollable>
      <v-card class="rounded-lg elevation-4">
        <!-- Toolbar Header -->
        <v-toolbar height="60" color="secondary" dark flat class="px-3">
          <v-icon left>mdi-image-multiple</v-icon>
          <span class="text-h6 font-weight-medium"
            >Detalle e Imágenes de Scrap</span
          >
          <v-chip
            v-if="Item && (Item.num_serie || Item.id)"
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 1.02rem; height: 34px"
          >
            <v-icon left size="18" color="secondary">mdi-barcode-scan</v-icon>
            Serie: {{ Item.num_serie || Item.id }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="cerrarDialogo" title="Cerrar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text
          class="pa-5"
          style="max-height: 80vh; background-color: #f8fafc"
        >
          <!-- Chips informativos del Neumático -->
          <div v-if="Item" class="d-flex align-center flex-wrap gap-2 mb-4">
            <v-chip
              v-if="Item.marca"
              small
              outlined
              class="font-weight-medium bg-white"
            >
              <strong class="mr-1">Marca:</strong> {{ Item.marca }}
            </v-chip>
            <v-chip
              v-if="Item.modelo"
              small
              outlined
              class="font-weight-medium bg-white"
            >
              <strong class="mr-1">Modelo:</strong> {{ Item.modelo }}
            </v-chip>
            <v-chip
              v-if="Item.medida"
              small
              outlined
              class="font-weight-medium bg-white"
            >
              <strong class="mr-1">Medida:</strong> {{ Item.medida }}
            </v-chip>
            <v-chip
              v-if="Item.disenio && Item.disenio !== '-'"
              small
              outlined
              class="font-weight-medium bg-white"
            >
              <strong class="mr-1">Diseño:</strong> {{ Item.disenio }}
            </v-chip>
            <v-chip
              v-if="Item.motivo"
              small
              color="amber lighten-4"
              text-color="amber darken-4"
              class="font-weight-bold"
            >
              <v-icon left x-small color="amber darken-4"
                >mdi-alert-circle-outline</v-icon
              >
              {{ Item.motivo }}
            </v-chip>
            <v-chip
              v-if="Item.fecha_scrap"
              small
              outlined
              class="font-weight-medium bg-white"
            >
              <v-icon left x-small>mdi-calendar</v-icon>
              {{ Item.fecha_scrap }}
            </v-chip>
          </div>

          <!-- Recomendación / Observaciones -->
          <div v-if="Item" class="mb-4">
            <v-alert
              color="info"
              border="left"
              colored-border
              elevation="1"
              icon="mdi-comment-text-outline"
              class="mb-0 rounded-lg white"
            >
              <div class="text-subtitle-2 font-weight-bold info--text mb-1">
                Recomendación / Observaciones:
              </div>
              <div
                class="body-2 grey--text text--darken-4"
                style="white-space: pre-line"
              >
                {{ getRecomendacion() }}
              </div>
            </v-alert>
          </div>

          <!-- Fotos de la inspección / Scrap -->
          <v-row dense>
            <!-- Foto 1 -->
            <v-col cols="12" sm="6" md="4">
              <v-card
                outlined
                class="pa-3 rounded-lg fill-height text-center photo-view-card bg-white"
              >
                <div
                  class="font-weight-bold text-caption mb-2 primary--text d-flex align-center justify-center"
                >
                  <v-icon small color="primary" class="mr-1">mdi-camera</v-icon>
                  IMAGEN 1
                </div>
                <div class="preview-box d-flex align-center justify-center">
                  <template v-if="getRutaImagen(1)">
                    <img
                      :src="getRutaImagen(1)"
                      alt="Neumático 1"
                      class="preview-img"
                      @click="
                        abrirZoom(
                          getRutaImagen(1),
                          'Imagen 1 - Serie ' + (Item.num_serie || ''),
                        )
                      "
                      title="Haga clic para ampliar la imagen"
                    />
                  </template>
                  <div v-else class="empty-state">
                    <v-icon large color="grey lighten-1"
                      >mdi-image-off-outline</v-icon
                    >
                    <span class="text-caption grey--text text--darken-1 mt-1"
                      >Imagen no disponible</span
                    >
                  </div>
                </div>
                <div v-if="getRutaImagen(1)" class="mt-2">
                  <v-btn
                    x-small
                    text
                    color="primary"
                    class="text-none font-weight-bold"
                    @click="
                      abrirZoom(
                        getRutaImagen(1),
                        'Imagen 1 - Serie ' + (Item.num_serie || ''),
                      )
                    "
                  >
                    <v-icon left x-small>mdi-magnify-plus-outline</v-icon>
                    Ampliar imagen
                  </v-btn>
                </div>
              </v-card>
            </v-col>

            <!-- Foto 2 -->
            <v-col cols="12" sm="6" md="4">
              <v-card
                outlined
                class="pa-3 rounded-lg fill-height text-center photo-view-card bg-white"
              >
                <div
                  class="font-weight-bold text-caption mb-2 primary--text d-flex align-center justify-center"
                >
                  <v-icon small color="primary" class="mr-1">mdi-camera</v-icon>
                  IMAGEN 2
                </div>
                <div class="preview-box d-flex align-center justify-center">
                  <template v-if="getRutaImagen(2)">
                    <img
                      :src="getRutaImagen(2)"
                      alt="Neumático 2"
                      class="preview-img"
                      @click="
                        abrirZoom(
                          getRutaImagen(2),
                          'Imagen 2 - Serie ' + (Item.num_serie || ''),
                        )
                      "
                      title="Haga clic para ampliar la imagen"
                    />
                  </template>
                  <div v-else class="empty-state">
                    <v-icon large color="grey lighten-1"
                      >mdi-image-off-outline</v-icon
                    >
                    <span class="text-caption grey--text text--darken-1 mt-1"
                      >Imagen no disponible</span
                    >
                  </div>
                </div>
                <div v-if="getRutaImagen(2)" class="mt-2">
                  <v-btn
                    x-small
                    text
                    color="primary"
                    class="text-none font-weight-bold"
                    @click="
                      abrirZoom(
                        getRutaImagen(2),
                        'Imagen 2 - Serie ' + (Item.num_serie || ''),
                      )
                    "
                  >
                    <v-icon left x-small>mdi-magnify-plus-outline</v-icon>
                    Ampliar imagen
                  </v-btn>
                </div>
              </v-card>
            </v-col>

            <!-- Foto 3 -->
            <v-col cols="12" sm="6" md="4">
              <v-card
                outlined
                class="pa-3 rounded-lg fill-height text-center photo-view-card bg-white"
              >
                <div
                  class="font-weight-bold text-caption mb-2 primary--text d-flex align-center justify-center"
                >
                  <v-icon small color="primary" class="mr-1">mdi-camera</v-icon>
                  IMAGEN 3
                </div>
                <div class="preview-box d-flex align-center justify-center">
                  <template v-if="getRutaImagen(3)">
                    <img
                      :src="getRutaImagen(3)"
                      alt="Neumático 3"
                      class="preview-img"
                      @click="
                        abrirZoom(
                          getRutaImagen(3),
                          'Imagen 3 - Serie ' + (Item.num_serie || ''),
                        )
                      "
                      title="Haga clic para ampliar la imagen"
                    />
                  </template>
                  <div v-else class="empty-state">
                    <v-icon large color="grey lighten-1"
                      >mdi-image-off-outline</v-icon
                    >
                    <span class="text-caption grey--text text--darken-1 mt-1"
                      >Imagen no disponible</span
                    >
                  </div>
                </div>
                <div v-if="getRutaImagen(3)" class="mt-2">
                  <v-btn
                    x-small
                    text
                    color="primary"
                    class="text-none font-weight-bold"
                    @click="
                      abrirZoom(
                        getRutaImagen(3),
                        'Imagen 3 - Serie ' + (Item.num_serie || ''),
                      )
                    "
                  >
                    <v-icon left x-small>mdi-magnify-plus-outline</v-icon>
                    Ampliar imagen
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3 bg-actions">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-2"
            text
            class="px-4 text-capitalize font-weight-bold"
            @click="cerrarDialogo"
          >
            <v-icon left small>mdi-close</v-icon>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Zoom / Vista Ampliada -->
    <v-dialog v-model="dialogZoom" max-width="880px">
      <v-card class="rounded-lg overflow-hidden">
        <v-toolbar dense flat color="grey darken-4" dark>
          <v-toolbar-title class="body-2 font-weight-bold">
            {{ zoomTitulo || "Vista ampliada" }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogZoom = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div
          class="pa-3 d-flex align-center justify-center"
          style="background-color: #0f172a; min-height: 350px"
        >
          <img
            :src="zoomImgUrl"
            style="
              max-width: 100%;
              max-height: 75vh;
              object-fit: contain;
              border-radius: 4px;
            "
            alt="Ampliación"
          />
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import global from "../../global";

export default {
  props: ["dialog", "Item"],
  data() {
    return {
      localDialog: this.dialog,
      ruta: "",
      dialogZoom: false,
      zoomImgUrl: "",
      zoomTitulo: "",
    };
  },
  watch: {
    dialog(newVal) {
      this.localDialog = newVal;
    },
    localDialog(newVal) {
      this.$emit("dialog", newVal);
    },
  },
  methods: {
    cerrarDialogo() {
      this.localDialog = false;
    },
    getRutaImagen(num) {
      if (!this.Item) return null;
      const key = `neumaticoimgruta${num}`;
      const path =
        this.Item[key] ||
        (this.Item.ultima_inspeccion && this.Item.ultima_inspeccion[key]);

      if (!path) return null;
      if (
        typeof path === "string" &&
        (path.startsWith("http://") || path.startsWith("https://"))
      ) {
        return path;
      }
      const base = this.ruta || global.ruta_image || "";
      const cleanBase = base.endsWith("/") ? base : base + "/";
      const cleanPath = path.startsWith("/") ? path.substring(1) : path;
      return cleanBase + cleanPath;
    },
    getRecomendacion() {
      if (!this.Item) return "Sin recomendación registrada.";
      return (
        this.Item.recomendacion ||
        (this.Item.ultima_inspeccion &&
          this.Item.ultima_inspeccion.recomendacion) ||
        "Sin recomendación registrada."
      );
    },
    abrirZoom(url, titulo) {
      this.zoomImgUrl = url;
      this.zoomTitulo = titulo;
      this.dialogZoom = true;
    },
  },
  mounted() {
    this.ruta = global.ruta_image;
  },
};
</script>

<style scoped>
.photo-view-card {
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.photo-view-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.preview-box {
  min-height: 220px;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
  overflow: hidden;
  padding: 6px;
}
.preview-img {
  width: 100%;
  max-height: 220px;
  object-fit: contain;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.preview-img:hover {
  transform: scale(1.03);
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
}
.bg-actions {
  background-color: #f8fafc;
}
.gap-2 {
  gap: 8px;
}
</style>
